module.exports = __webpack_public_path__ + "d0cf09c0dfc69796bb1ec666bd98b1a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-winter-green-s.png
// module id = 2912
// module chunks = 0